import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Route, Routes, useNavigate } from 'react-router-dom';
import { NotFoundPage } from 'libs.react';
import { WorkspaceSite, WorkspaceSiteList } from './pages';
export const SiteManagementApp = () => {
    const navigate = useNavigate();
    return (_jsxs(Routes, { children: [_jsx(Route, { index: true, path: 'dashboard', element: _jsx(WorkspaceSiteList, {}) }), _jsx(Route, { path: 'workspace-site/:workspaceSiteId', element: _jsx(WorkspaceSite, {}) }), _jsx(Route, { path: '*', element: _jsx(NotFoundPage, { goBack: () => navigate(-1) }) })] }));
};
export { SITE_MANAGEMENT_FLAGS } from './constants';
